import { FC } from 'react';
import {
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/** Always-visible table search; no hover-expand mystery UX */
export const TableSearchInput: FC<TextFieldProps> = (props) => {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      placeholder={t('search') || ''}
      {...props}
      sx={{
        width: { xs: '100%', sm: 280 },
        transitionProperty: 'box-shadow',
        transitionDuration: '150ms',
        transitionTimingFunction: 'cubic-bezier(0.2, 0, 0, 1)',
        ...((props.sx as object) || {}),
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon
              fontSize="small"
              sx={{ opacity: props.disabled ? 0.5 : 0.7 }}
            />
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
    />
  );
};
